import { apiSlice } from "app/api/apiSlice.ts";
import type {
  PageVideoPopup,
  PageVideoPopupPayload,
} from "./pageVideoPopupTypes.ts";

export const pageVideoPopupsApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getActivePageVideoPopups: build.query<PageVideoPopup[], void>({
      query: () => "/api/v2/page-video-popups/active",
      providesTags: ["pageVideoPopups"],
    }),
    getPageVideoPopups: build.query<PageVideoPopup[], void>({
      query: () => "/api/v2/page-video-popups",
      providesTags: ["pageVideoPopups"],
    }),
    createPageVideoPopup: build.mutation<PageVideoPopup, PageVideoPopupPayload>(
      {
        query: (body) => ({
          url: "/api/v2/page-video-popups",
          method: "POST",
          body,
        }),
        invalidatesTags: ["pageVideoPopups"],
      },
    ),
    updatePageVideoPopup: build.mutation<
      PageVideoPopup,
      { id: number; body: PageVideoPopupPayload }
    >({
      query: ({ id, body }) => ({
        url: `/api/v2/page-video-popups/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["pageVideoPopups"],
    }),
    deletePageVideoPopup: build.mutation<PageVideoPopup, number>({
      query: (id) => ({
        url: `/api/v2/page-video-popups/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["pageVideoPopups"],
    }),
  }),
});

export const {
  useGetActivePageVideoPopupsQuery,
  useGetPageVideoPopupsQuery,
  useCreatePageVideoPopupMutation,
  useUpdatePageVideoPopupMutation,
  useDeletePageVideoPopupMutation,
} = pageVideoPopupsApiSlice;
